import { api } from '.';
import { NoticeCategory } from '../constants';
import { INotice } from '../model';
import { toQueryString } from './../utils/misc';

export const fetchNotices = async (category: NoticeCategory) => {
  const { data } = await api.get<INotice[]>(
    `/notices/${toQueryString({
      category,
      service: 'standard',
    })}`
  );

  return data;
};

export const fetchNotice = async (id: number) => {
  const { data } = await api.get<INotice>(`/notices/${id}/`);
  return data;
};
